<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
  <div [ngSwitch]="task">
    <ng-template ngSwitchCase = "list">
      <!-- <pre>{{projectManagement$ | async | json}}</pre> -->
      <mrsoftapps-project-progress
      [countries]="country$ | async"
      [states]="state$ | async"
      [lgas]="lga$ | async"
      [projectTypes]="projectType$ | async"
      [projectCategories]="projectCategory$ | async"
      [oilBlocks]="oilBlock$ | async"
      [oilFields]="oilField$ | async"
      [communities]="community$ | async"
      [clusters]="cluster$ | async"
      [currencies]="currency$ | async"
      [clusterCommunity]="clusterCommunity$ | async"
      [projectManagements]="projectManagement$ | async"
      [progressHistoryReports]="progressHistoryReport$ | async"
      [progressMasterReports]="progressMasterReport$ | async"
      [progressMeetingReports]="progressMeetingReport$ | async"
      [gmous]="gmou$ | async"
      [documentCategory]="documentCategory$ | async"
      [documentSubCategory]="documentSubCategory$ | async"
      (changeEmit)="onTriggerEmit($event)"
      (onActivityEmit)="onEmitActivity($event)"
      (onSaveReportMeeting)="onSaveProgressMeeting($event)"
      (onSaveReportHistory)="onSaveProgressHistory($event)"
      (onSaveReportMaster)="onSaveProgressMaster($event)"
      (deleteEvent)="onDeleteEVent($event)"
      (onDeleteReportMaster)="onDeleteReportMaster($event)"
      (onDeleteMeeting)="onDeleteMeeting($event)"
      (taskEmit)="taskEvent($event)"
      *ngIf="
      !(isLoadingProjectManagement$ | async) &&
      !(isLoadingCountry$ | async) &&
      !(isLoadingState$ | async) &&
      !(isLoadingLga$ | async) &&
      !(isLoadingCommunity$ | async) &&
      !(isLoadingProjectType$ | async) &&
      !(isLoadingCluster$ | async) &&
      !(isLoadingClusterCommunity$ | async) &&
      !(isLoadingProjectCategory$ | async) &&
      !(isLoadingOilBlock$ | async) &&
      !(isLoadingOilField$ | async) &&
      !(isLoadingDocumentCategory$ | async) &&
      !(isLoadingDocumentSubCategory$ | async) &&
      !(isLoadingGmou$ | async) &&
      !(isLoadingCurrency$ | async) &&
      !(isLoadingProgressHistoryReport$ | async) &&
      !(isLoadingProgressMasterReport$ | async) &&
      !(isLoadingProgressMeetingReport$ | async)
"
      >


      </mrsoftapps-project-progress>

    </ng-template>

  </div>



<mrsoftapps-epims-reference-spinner
*ngIf="
(isLoadingProjectManagement$ | async) ||
(isLoadingCountry$ | async) ||
(isLoadingState$ | async) ||
(isLoadingLga$ | async) ||
(isLoadingCommunity$ | async) ||
(isLoadingProjectType$ | async) ||
(isLoadingCluster$ | async) ||
(isLoadingClusterCommunity$ | async) ||
(isLoadingProjectCategory$ | async) ||
(isLoadingOilBlock$ | async) ||
(isLoadingOilField$ | async) ||
(isLoadingDocumentCategory$ | async) ||
(isLoadingDocumentSubCategory$ | async) ||
(isLoadingGmou$ | async) ||
(isLoadingCurrency$ | async) ||
(isLoadingProgressHistoryReport$ | async) ||
(isLoadingProgressMasterReport$ | async) ||
(isLoadingProgressMeetingReport$ | async)

"


></mrsoftapps-epims-reference-spinner>
</main>
</div>
</dashboardnav>
